/* eslint-disable eqeqeq */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react'
import styled from 'styled-components'
import { addBarcodes } from '../utils/addBarcodes'
import BarcodeReader from 'react-barcode-reader'
import { useMutation } from 'react-query'
import { useLocation, useNavigate } from 'react-router-dom'
import Container from '../components/container/Container'
import Banner from '../components/hero/Banner'
import Header from '../components/header/Header'
import SuccessFlash from '../components/flash_message/SuccessFlash'
import ErrorFlash from '../components/flash_message/ErrorFlash'
import FormValidationError from '../components/flash_message/FormValidationError'
import useAxiosPrivate from '../hooks/useAxiosPrivate'
import useAuth from '../hooks/useAuth'
import { playBeepingSound } from '../utils/playSound'
import ModalDrop from '../components/modals/ModalDrop'
import ScanError from '../components/scanning-error/ScanError'
import moment from 'moment'
const SetChildren = styled.div`
  margin-top: 18px;
  width: 100%;
`
const Middle = styled.div`
  margin-top: 18px;
  width: 100%;
`
const Input = styled.input`
  width: ${props => props.width};
  border: 1px solid #d6d6d6;
  color: black;
  font-size: 16px;
  border-radius: 5px;
  height: 40px;
  padding: 0 5px;
`
const Label = styled.label`
  width: 100%;
  color: #8a8a8a;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: 0px;
  text-align: left;
`
const FormInputControl = styled.div`
  width: 100%;
  margin: 10px 0;
`

function UnpackPackage () {
  const axiosprivate = useAxiosPrivate()
  const location = useLocation()
  const { auth, setLoading } = useAuth()
  const [barcode, setBarcode] = useState('Scan barcode...................')
  const [longitude, setLongitude] = useState('')
  const [latitude, setLatitude] = useState('')
  const [isSuccess, setIsSuccess] = useState(false)
  const [isFail, setIsFail] = useState(false)
  const navigate = useNavigate()
  const [packQty, setPackQty] = useState(0)
  const [isParent, setIsParent] = useState(true)
  const [parentCount, setParentCount] = useState(0)
  const [childrenCount, setChildrenCount] = useState(0)
  const [parent, setParent] = useState([])
  const [children, setChildren] = useState([])
  const [message, setMessage] = useState('Success')
  const [incompleteScan, setIncompleteScan] = useState(false)
  const [scanError, setScanError] = useState({ show: false, barcode: '' })

  useEffect(() => {
    childrenCount == packQty && childrenCount != 0 && handleSubmit()
  }, [childrenCount])

  //clear out scan box
  useEffect(() => {
    setTimeout(() => {
      setBarcode('Scan barcode...................')
    }, 1000)
    return () => {
      clearTimeout()
    }
  }, [barcode])

  useEffect(() => {
    navigator.permissions.query({ name: 'geolocation' }).then(resp => {
      if (resp.state === 'granted') {
        if (navigator.geolocation) {
          navigator.geolocation.getCurrentPosition(success, error)
        }
      } else if (resp.state === 'denied') {
        navigate('/', { state: { from: location }, replace: true })
      }
    })

    function success (position) {
      setLatitude(`${position.coords.latitude}`)
      setLongitude(`${position.coords.longitude}`)
    }

    function error (err) {
      console.error(err)
      navigate('/', { state: { from: location }, replace: true })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  //get barcodes
  const handleScan = async data => {
    setIncompleteScan(false)
    setBarcode(data)
    setIsFail(false)
    setIsSuccess(false)

    //check if label is parent
    if (isParent) {
      //check if label is SSCC
      if (data.substring(0, 2) === '00' && data.substring(3, 6) === '615') {
        if (data.length < 20) {
          setIncompleteScan(true)
          return
        } else {
          packContent.mutate(data)
          return
        }
      } else {
        //this means the label is SGTIN
        if (data.length < 40) {
          setIncompleteScan(true)
          return
        } else {
          packContent.mutate(data)
          return
        }
      }
    } else {
      //check if label is SSCC
      if (data.substring(0, 2) === '00' && data.substring(3, 6) === '615') {
        if (data.length < 20) {
          setIncompleteScan(true)
          playBeepingSound()
          return
        } else {
          // Update the addBarcodes calls
          let filteredArray = addBarcodes(data, children)
          setChildrenCount(filteredArray.length)
          setChildren([...filteredArray])
          return
        }
      } else {
        if (data.length < 40) {
          setIncompleteScan(true)
          playBeepingSound()
          return
        } else {
          let filteredArray = addBarcodes(data, children)
          setChildrenCount(filteredArray.length)
          setChildren([...filteredArray])
          return
        }
      }
    }
  }

  //handle error
  function handleError (err) {
    console.error(err)
  }

  //Endpoint to unpack
  const unpackPackageContent = async data => {
    return await axiosprivate.post('/gs1/standard/label/unpack', data)
  }
  //Endpoint to get pack content Qty
  const getPackContent = async barcode => {
    const clientId = auth.user.clientId || 4
    return await axiosprivate.get(
      `/gs1/standard/label/content/${clientId}/${barcode}`
    )
  }

  //query to send to backend
  const { mutate, isLoading } = useMutation(
    variables => unpackPackageContent(variables),
    {
      onSuccess (data, variables, context) {
        setPackQty(0)
        setIsParent(true)
        setChildrenCount(0)
        setParentCount(0)
        setParent([])
        setChildren([])
        setIsSuccess(true)
        setMessage('Success')
      },
      onError (error) {
        setIsParent(true)
        setChildrenCount(0)
        setParentCount(0)
        setParent([])
        setChildren([])
        setIsFail(true)
        if (error.code === 'ERR_NETWORK')
          setMessage('Please Check Your Network')
        else if (
          error?.response?.status === 403 ||
          error?.response?.status === 401
        )
          navigate('/', { state: { from: location }, replace: true })
        else {
          const message = error.response.data.message
          if (message.includes('SQL') || error?.response?.status === 500) {
            setMessage('Server Error')
          } else {
            setMessage(
              error.response.data.message?.replace('Unknow', 'Unknown')
            )
          }
        }
      }
    }
  )
  //   const packContent = useMutation(variables => getPackContent(variables), {

  const handleSubmit = () => {
    const offset = moment().format('Z')
    const payload = {
      clientId: auth.user.clientId || 4,
      eventObjectParameter: {
        readPoint: auth.user.location || '6156000010014',
        eventTime: new Date().toISOString().replace('Z', ''),
        recordTime: new Date().toISOString().replace('Z', ''),
        latitude: latitude,
        longitude: longitude,
        bizStep: 'urn:epcglobal:cbv:bizstep:unpacking',
        disposition: 'urn:epcglobal:cbv:disp:active',
        timeZone: offset
      },
      unpackingData: {
        parent: parent[0], // This should be the parent barcode
        children: children.map(child => child.elementString || child) // Extract elementString if needed
      }
    }
    mutate(payload)
  }

  const packContent = useMutation(variables => getPackContent(variables), {
    onSuccess (data, variables, context) {

      // Check if data exists and has content
      if (data?.data?.length > 0) {
        setPackQty(data.data.length)
        setParentCount(1)

        // The response is an array, so get the first item's elementString
        // If you need the parent barcode, it should be the variable that was passed
        setParent([...parent, variables]) // Use the scanned barcode as parent

        setIsParent(false)
        setIsFail(false) // Clear any previous errors
      } else {
        // Handle empty response
        setIsFail(true)
        setMessage('No content found in package')
        playBeepingSound()
      }
    },
    onError (error) {
      setIsParent(true)
      setParentCount(0)
      setParent([])
      setIsFail(true)
      if (error.code === 'ERR_NETWORK') setMessage('Please Check Your Network')
      else if (
        error?.response?.status === 401 ||
        error?.response?.status === 403
      )
        navigate('/', { state: { from: location }, replace: true })
      else setMessage(error.response.data.message?.replace('unknow', 'Unknown'))
    }
  })

  const resetScanError = () => {
    setScanError({ show: false, barcode: '' })
  }

  //   useEffect(() => {
  //     setLoading(isLoading || packContent.isLoading)
  //   }, [isLoading, setLoading, packContent.isLoading])

  useEffect(() => {
    setLoading(isLoading || packContent.isLoading)
  }, [isLoading, packContent.isLoading, setLoading])

  useEffect(() => {
    // Clear error states when barcode changes
    if (barcode !== 'Scan barcode...................') {
      setIsFail(false)
      setIncompleteScan(false)
    }
  }, [barcode])

  return (
    <Container>
      {scanError.show && (
        <ModalDrop>
          <ScanError
            onClose={resetScanError}
            barCode={scanError.barcode}
            errorMessage={scanError.errorMessage}
          />
        </ModalDrop>
      )}
      <Header>{'Unpack Package'}</Header>
      <Banner />
      <SetChildren>
        <BarcodeReader
          onError={handleError}
          onScan={handleScan}
          timeBeforeScanTest={1000}
        />
        <FormInputControl>
          <Label>{isParent ? 'Scan Parent' : 'Scan Children'}</Label>
        </FormInputControl>
        <FormInputControl>
          <Input
            value={barcode}
            width={'100%'}
            style={{ fontSize: '12px' }}
            disabled
          />
          {incompleteScan && (
            <FormValidationError text={'Incomplete scan.. please rescan!!!!'} />
          )}
        </FormInputControl>
      </SetChildren>
      {parentCount > 0 && (
        <Middle>
          <FormInputControl>
            <Label>Pack Content Quantity</Label>
          </FormInputControl>
          <FormInputControl>
            <Input width={'100%'} value={packQty} disabled type='number' />
          </FormInputControl>
          <>
            {' '}
            <FormInputControl>
              <Label>Children Count</Label>
            </FormInputControl>
            <FormInputControl>
              <Input
                width={'100%'}
                value={childrenCount}
                disabled
                type='number'
              />
            </FormInputControl>
          </>
        </Middle>
      )}

      <FormInputControl style={{ marginTop: '20px' }}>
        <SuccessFlash display={isSuccess}>{message}</SuccessFlash>
      </FormInputControl>

      <FormInputControl style={{ marginTop: '20px' }}>
        <ErrorFlash display={isFail}>{message}</ErrorFlash>
      </FormInputControl>
    </Container>
  )
}

export default UnpackPackage
